import React from 'react';
const SampleArrowPrev = props => {
  const { className, clickPrevCard = null } = props;
  return (
    <div
      className={className}
      onClick={() => {
        clickPrevCard();
      }}
      tabIndex='0'
      aria-label='previous button'
      data-testid='prev-button-handler'
    />
  );
};

export default SampleArrowPrev;
